import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Level from '../views/Level.vue'
import Apartment from '../views/Apartment.vue'
import Gallery from '../views/Gallery.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      order: 0
    }
  },
  {
    path: '/levels/:level',
    name: 'levels',
    component: Level,
    meta: {
      order: 10
    }
  },
  {
    path: '/apartment/:apartment',
    name: 'apartment',
    component: Apartment,
    meta: {
      order: 20
    }
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: Gallery,
    meta: {
      order: 20
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
